import { useEventCallback } from '@cian/react-utils';
import { Button } from '@cian/ui-kit';
import { IconActionClose16, IconSocialDislikeOn16, IconSocialLikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { toggleComplainPopup } from 'shared/store/hideOffer';

import { trackFeedbackOptionClick } from '../../../tracking';
import * as styles from '../styles/styles.css';

interface IQuestionBlockProps {
  onYesButtonClick(): void;
  onDidNotPickUpPhoneButtonClick(): void;
}

export function QuestionBlock(props: IQuestionBlockProps) {
  const dispatch = useDispatch();

  const openModalComplain = useEventCallback(() => {
    dispatch(toggleComplainPopup(true));
  });

  const { onYesButtonClick, onDidNotPickUpPhoneButtonClick } = props;

  const handleNoButtonClick = () => {
    trackFeedbackOptionClick('not_confirmed');

    openModalComplain();
  };

  const handleYesButtonClick = () => {
    trackFeedbackOptionClick('confirmed');

    onYesButtonClick();
  };

  const handleDidNotPickUpPhoneButtonClick = () => {
    trackFeedbackOptionClick('no_answer');

    onDidNotPickUpPhoneButtonClick();
  };

  return (
    <div className={styles['question_block']}>
      Подтвердилась ли информация, указанная в объявлении?
      <div className={styles['actions']}>
        <div className={styles['action_button']}>
          <Button
            beforeIcon={<IconSocialDislikeOn16 color="current_color" />}
            size="XS"
            theme="fill_secondary"
            onClick={handleNoButtonClick}
          >
            Нет
          </Button>
        </div>

        <div className={styles['action_button']}>
          <Button
            beforeIcon={<IconSocialLikeOn16 color="current_color" />}
            size="XS"
            theme="fill_secondary"
            onClick={handleYesButtonClick}
          >
            Да
          </Button>
        </div>

        <div className={styles['action_button']}>
          <Button
            size="XS"
            theme="fill_secondary"
            onClick={handleDidNotPickUpPhoneButtonClick}
            beforeIcon={<IconActionClose16 color="current_color" />}
          >
            Не взяли трубку
          </Button>
        </div>
      </div>
    </div>
  );
}
